<template>
  <div :class="[ showAnim ? 'full-spinner--show-anim' : '',
    done && !showAnim ? 'full-spinner--hide-anim' : '',
    'full-spinner']">
    <fai icon="spinner" class="full-spinner__spinner full-spinner__spinner-anim"/>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showAnim: false,
      done: false
    }
  },

  props: {
    animDuration: {
      type: Number,
      default: 500
    },
    signalDone: false
  },

  watch: {
    signalDone () {
      // showing animation already played
      if(!this.showAnim) {
        this.done = true
        setTimeout(() => {
          this.$emit('done')
        }, this.animDuration)
      }
    }
  },

  mounted () {
    this.showAnim = true
    setTimeout(() => {
      this.showAnim = false
      if(this.signalDone) {
        this.done = true
        setTimeout(() => {
          this.$emit('done')
        }, this.animDuration)
      }
    }, this.animDuration)
  },

  methods: {

  }
}
</script>

<style lang="scss">
.full-spinner {
  position: absolute;
  height: 100%;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(189, 56, 73, 0.9);

  &--show-anim {
    animation-name: show-anim;
    animation-duration: 0.5s;
    animation-timing-function: linear;
  }

  @keyframes show-anim {
    from { background: rgba(189, 56, 73, 0) }
    to { background: rgba(189, 56, 73, 0.9) }
  }

  &--hide-anim {
    animation-name: hide-anim;
    animation-duration: 0.5s;
    animation-timing-function: linear;
  }

  @keyframes hide-anim {
    from { background: rgba(189, 56, 73, 0.9) }
    to { background: rgba(189, 56, 73, 0) }
  }

  &__spinner {
    color: white;
  }

  &__spinner-anim {
    animation-name: spinner-rotate;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }

  @keyframes spinner-rotate {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
}
</style>
